import { defineNuxtPlugin } from '#app/nuxt'
import { LazyArisCheckbox, LazyArisCorpVideoplayer, LazyArisSelectMenu, LazyArisUFormGroup, LazyArisUSelectMenu, LazyButtonDefault, LazyCommLinkCard, LazyCommandPalette, LazyDefaultPanelOld, LazyDefaultPanel, LazyDisclosure, LazyEditorButtonBlockquote, LazyEditorButtonBold, LazyEditorButtonBulletList, LazyEditorButtonCenter, LazyEditorButtonClearFormatting, LazyEditorButtonColor, LazyEditorButtonComponents, LazyEditorButtonDivider, LazyEditorButtonFullscreen, LazyEditorButtonImage, LazyEditorButtonItalic, LazyEditorButtonJustify, LazyEditorButtonLeft, LazyEditorButtonLink, LazyEditorButtonOrderedList, LazyEditorButtonRedo, LazyEditorButtonRight, LazyEditorButtonStrike, LazyEditorButtonSubscript, LazyEditorButtonSuperscript, LazyEditorButtonTable, LazyEditorButtonType, LazyEditorButtonUnderline, LazyEditorButtonUndo, LazyEditorButtonVideo, LazyEditorComponentPanelWithBg, LazyEditorComponentPanel, LazyEditorFileLibrary, LazyEditor, LazyFileLibraryFolderItem, LazyFileLibrary, LazyFooter, LazyIconHover, LazyIconsLogosAmsBanner, LazyIconsLogosAriscorpBanner, LazyIconsLogosAriscorp, LazyIconsLogosArk, LazyIconsLogosCig, LazyIconsLogosGalactapedia, LazyIconsLogosRoadmap, LazyIconsLogosRsiCommLink, LazyIconsLogosRsi, LazyIconsLogosSeBanner, LazyIconsLogosSquadron42, LazyIconsLogosStarcitizen, LazyIconsLogosUec, LazyIconsLogosVeBanner, LazyIconsNavigationAliens, LazyIconsNavigationCommLink, LazyIconsNavigationCompanies, LazyIconsNavigationDepartments, LazyIconsNavigationFleet, LazyIconsNavigationHangar, LazyIconsNavigationHistory, LazyIconsNavigationMembers, LazyIconsNavigationPartner, LazyIconsNavigationRecruitment, LazyIconsNavigationSpectrum, LazyIconsNavigationStarmap, LazyIconsNavigationStarmapBanu, LazyIconsNavigationStarmapBoundaries, LazyIconsNavigationStarmapDistances, LazyIconsNavigationStarmapExploration, LazyIconsNavigationStarmapIndevelopment, LazyIconsNavigationStarmapJumppoints, LazyIconsNavigationStarmapMainTab, LazyIconsNavigationStarmapUee, LazyIconsNavigationStarmapUnclaimed, LazyIconsNavigationStarmapVanduul, LazyIconsNavigationStarmapXian, LazyIconsNavigationTechnology, LazyIconsNavigationTimeline, LazyIconsNavigationUee, LazyImageHoverEffect, LazyLoadingBasic, LazyMemberCard, LazyShipCard, LazyShipQuickView, LazySidebarOverlay, LazySidebar, LazySlideover, LazyTabGroupVertical, LazyTabGroup, LazyTableHr, LazyTableParent, LazyTableRow, LazyTheModal, LazyAmsAdministrationUserTable, LazyArcCounter, LazyHomeSectionCommLink, LazyHomeSectionDepartments, LazyHomeSectionFleet, LazyHomeSectionMembers, LazyHomeSectionPartner, LazyHomeSectionRecruitment, LazyHomeTheNavbar, LazySentryTestButton, LazyTcientosOrbitControls, LazyTcientosUseGLTFComponent, LazyTcientosUseGLTF, LazyVerseExkursBaseArticle, LazyResetPw, LazyTemp, LazyIcon } from '#components'
const lazyGlobalComponents = [
  ["ArisCheckbox", LazyArisCheckbox],
["ArisCorpVideoplayer", LazyArisCorpVideoplayer],
["ArisSelectMenu", LazyArisSelectMenu],
["ArisUFormGroup", LazyArisUFormGroup],
["ArisUSelectMenu", LazyArisUSelectMenu],
["ButtonDefault", LazyButtonDefault],
["CommLinkCard", LazyCommLinkCard],
["CommandPalette", LazyCommandPalette],
["DefaultPanelOld", LazyDefaultPanelOld],
["DefaultPanel", LazyDefaultPanel],
["Disclosure", LazyDisclosure],
["EditorButtonBlockquote", LazyEditorButtonBlockquote],
["EditorButtonBold", LazyEditorButtonBold],
["EditorButtonBulletList", LazyEditorButtonBulletList],
["EditorButtonCenter", LazyEditorButtonCenter],
["EditorButtonClearFormatting", LazyEditorButtonClearFormatting],
["EditorButtonColor", LazyEditorButtonColor],
["EditorButtonComponents", LazyEditorButtonComponents],
["EditorButtonDivider", LazyEditorButtonDivider],
["EditorButtonFullscreen", LazyEditorButtonFullscreen],
["EditorButtonImage", LazyEditorButtonImage],
["EditorButtonItalic", LazyEditorButtonItalic],
["EditorButtonJustify", LazyEditorButtonJustify],
["EditorButtonLeft", LazyEditorButtonLeft],
["EditorButtonLink", LazyEditorButtonLink],
["EditorButtonOrderedList", LazyEditorButtonOrderedList],
["EditorButtonRedo", LazyEditorButtonRedo],
["EditorButtonRight", LazyEditorButtonRight],
["EditorButtonStrike", LazyEditorButtonStrike],
["EditorButtonSubscript", LazyEditorButtonSubscript],
["EditorButtonSuperscript", LazyEditorButtonSuperscript],
["EditorButtonTable", LazyEditorButtonTable],
["EditorButtonType", LazyEditorButtonType],
["EditorButtonUnderline", LazyEditorButtonUnderline],
["EditorButtonUndo", LazyEditorButtonUndo],
["EditorButtonVideo", LazyEditorButtonVideo],
["EditorComponentPanelWithBg", LazyEditorComponentPanelWithBg],
["EditorComponentPanel", LazyEditorComponentPanel],
["EditorFileLibrary", LazyEditorFileLibrary],
["Editor", LazyEditor],
["FileLibraryFolderItem", LazyFileLibraryFolderItem],
["FileLibrary", LazyFileLibrary],
["Footer", LazyFooter],
["IconHover", LazyIconHover],
["IconsLogosAmsBanner", LazyIconsLogosAmsBanner],
["IconsLogosAriscorpBanner", LazyIconsLogosAriscorpBanner],
["IconsLogosAriscorp", LazyIconsLogosAriscorp],
["IconsLogosArk", LazyIconsLogosArk],
["IconsLogosCig", LazyIconsLogosCig],
["IconsLogosGalactapedia", LazyIconsLogosGalactapedia],
["IconsLogosRoadmap", LazyIconsLogosRoadmap],
["IconsLogosRsiCommLink", LazyIconsLogosRsiCommLink],
["IconsLogosRsi", LazyIconsLogosRsi],
["IconsLogosSeBanner", LazyIconsLogosSeBanner],
["IconsLogosSquadron42", LazyIconsLogosSquadron42],
["IconsLogosStarcitizen", LazyIconsLogosStarcitizen],
["IconsLogosUec", LazyIconsLogosUec],
["IconsLogosVeBanner", LazyIconsLogosVeBanner],
["IconsNavigationAliens", LazyIconsNavigationAliens],
["IconsNavigationCommLink", LazyIconsNavigationCommLink],
["IconsNavigationCompanies", LazyIconsNavigationCompanies],
["IconsNavigationDepartments", LazyIconsNavigationDepartments],
["IconsNavigationFleet", LazyIconsNavigationFleet],
["IconsNavigationHangar", LazyIconsNavigationHangar],
["IconsNavigationHistory", LazyIconsNavigationHistory],
["IconsNavigationMembers", LazyIconsNavigationMembers],
["IconsNavigationPartner", LazyIconsNavigationPartner],
["IconsNavigationRecruitment", LazyIconsNavigationRecruitment],
["IconsNavigationSpectrum", LazyIconsNavigationSpectrum],
["IconsNavigationStarmap", LazyIconsNavigationStarmap],
["IconsNavigationStarmapBanu", LazyIconsNavigationStarmapBanu],
["IconsNavigationStarmapBoundaries", LazyIconsNavigationStarmapBoundaries],
["IconsNavigationStarmapDistances", LazyIconsNavigationStarmapDistances],
["IconsNavigationStarmapExploration", LazyIconsNavigationStarmapExploration],
["IconsNavigationStarmapIndevelopment", LazyIconsNavigationStarmapIndevelopment],
["IconsNavigationStarmapJumppoints", LazyIconsNavigationStarmapJumppoints],
["IconsNavigationStarmapMainTab", LazyIconsNavigationStarmapMainTab],
["IconsNavigationStarmapUee", LazyIconsNavigationStarmapUee],
["IconsNavigationStarmapUnclaimed", LazyIconsNavigationStarmapUnclaimed],
["IconsNavigationStarmapVanduul", LazyIconsNavigationStarmapVanduul],
["IconsNavigationStarmapXian", LazyIconsNavigationStarmapXian],
["IconsNavigationTechnology", LazyIconsNavigationTechnology],
["IconsNavigationTimeline", LazyIconsNavigationTimeline],
["IconsNavigationUee", LazyIconsNavigationUee],
["ImageHoverEffect", LazyImageHoverEffect],
["LoadingBasic", LazyLoadingBasic],
["MemberCard", LazyMemberCard],
["ShipCard", LazyShipCard],
["ShipQuickView", LazyShipQuickView],
["SidebarOverlay", LazySidebarOverlay],
["Sidebar", LazySidebar],
["Slideover", LazySlideover],
["TabGroupVertical", LazyTabGroupVertical],
["TabGroup", LazyTabGroup],
["TableHr", LazyTableHr],
["TableParent", LazyTableParent],
["TableRow", LazyTableRow],
["TheModal", LazyTheModal],
["AmsAdministrationUserTable", LazyAmsAdministrationUserTable],
["ArcCounter", LazyArcCounter],
["HomeSectionCommLink", LazyHomeSectionCommLink],
["HomeSectionDepartments", LazyHomeSectionDepartments],
["HomeSectionFleet", LazyHomeSectionFleet],
["HomeSectionMembers", LazyHomeSectionMembers],
["HomeSectionPartner", LazyHomeSectionPartner],
["HomeSectionRecruitment", LazyHomeSectionRecruitment],
["HomeTheNavbar", LazyHomeTheNavbar],
["SentryTestButton", LazySentryTestButton],
["TcientosOrbitControls", LazyTcientosOrbitControls],
["TcientosUseGLTFComponent", LazyTcientosUseGLTFComponent],
["TcientosUseGLTF", LazyTcientosUseGLTF],
["VerseExkursBaseArticle", LazyVerseExkursBaseArticle],
["ResetPw", LazyResetPw],
["Temp", LazyTemp],
["Icon", LazyIcon],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
